var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstructionSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "construction sign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "#9ca3af",
    stroke: "#9ca3af"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 45,
    x2: 8,
    y2: 32,
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 32,
    x2: 14,
    y2: 45,
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 32,
    x2: 40,
    y2: 45,
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 45,
    x2: 34,
    y2: 32,
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 45,
    x2: 18,
    y2: 45,
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 45,
    x2: 44,
    y2: 45,
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 9 14 3 8 3 8 9",
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40 9 40 3 34 3 34 9",
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 26,
    y2: 27,
    fill: "none",
    strokeMiterlimit: 10,
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14,
    x2: 15,
    y2: 27,
    fill: "none",
    strokeMiterlimit: 10,
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 9,
    x2: 46,
    y2: 22,
    fill: "none",
    strokeMiterlimit: 10,
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 9,
    x2: 40,
    y2: 27,
    fill: "none",
    strokeMiterlimit: 10,
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 44,
    height: 18,
    fill: "none",
    stroke: "#9ca3af",
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionSign);
export default __webpack_public_path__ + "static/media/construction-sign.ce6a149a.svg";
export { ForwardRef as ReactComponent };